import React, { useEffect, useState } from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { compose } from 'recompose';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import styles from './styles';
import appConstants from '../../../../appConstants';
import { checkIfSameDay, getPastDate, getFutureDate } from '../../utils/dateTimeUtils';
import { getDateRangeInputValue } from './utils';

const PickerComponent = ({
  classes,
  theme,
  value,
  onChange,
  staticRanges,
  closePicker,
  minDate,
  maxDate,
  maxRange
}) => {
  const [maxAllowedDate, setMaxAllowedDate] = useState(maxDate);
  const [minAllowedDate, setMinAllowedDate] = useState(minDate);

  useEffect(() => {
    document.addEventListener('keydown', hideOnEscape, { capture: true });
    return () => {
      document.removeEventListener('keydown', hideOnEscape);
    };
  }, []);

  const hideOnEscape = (e) => {
    if (e.key === 'Escape') {
      closePicker();
    }
  };

  const handleChange = (ranges) => {
    const { selection } = ranges;
    const { startDate, endDate } = selection;

    onChange({ startDate, endDate });

    if (maxRange) {
      handleRangeLimit(startDate, endDate);
    }
  };

  const handleRangeLimit = (startDate, endDate) => {
    if (startDate && checkIfSameDay(startDate, endDate)) {
      const maxRangeDate = getFutureDate(maxRange - 1, startDate);
      const minRangeDate = getPastDate(maxRange - 1, startDate);

      const effectiveMaxDate = maxDate && maxRangeDate > maxDate ? maxDate : maxRangeDate;
      const effectiveMinDate = minDate && minRangeDate < minDate ? minDate : minRangeDate;

      setMaxAllowedDate(effectiveMaxDate);
      setMinAllowedDate(effectiveMinDate);
    } else {
      setMaxAllowedDate(maxDate);
      setMinAllowedDate(minDate);
    }
  };

  const ranges = getDateRangeInputValue(value);

  return (
    <ClickAwayListener onClickAway={closePicker}>
      <DateRangePicker
        className={classes.selectDate}
        rangeColors={[theme.palette.primary.main]}
        onChange={handleChange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={1}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        ranges={ranges}
        inputRanges={[]}
        dateDisplayFormat={appConstants.DATETYPES.MONTHDATEYEAR.format}
        direction="vertical"
        editableDateInputs
        color={theme.palette.primary.main}
        handleClose={closePicker}
        staticRanges={staticRanges}
        {...(maxAllowedDate && { maxDate: maxAllowedDate })}
        {...(minAllowedDate && { minDate: minAllowedDate })}
      />
    </ClickAwayListener>
  );
};

export default compose(withStyles(styles), withTheme())(PickerComponent);
